import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const PRESETS = [
  { label: 'First Four', windows: [
    { label: 'First Four Day 1', startDate: '2026-03-17', startTime: '17:00', endDate: '2026-03-18', endTime: '02:00' },
    { label: 'First Four Day 2', startDate: '2026-03-18', startTime: '17:00', endDate: '2026-03-19', endTime: '02:00' },
  ]},
  { label: 'Round of 64', windows: [
    { label: 'R64 Day 1 (Thu)', startDate: '2026-03-19', startTime: '11:00', endDate: '2026-03-20', endTime: '02:00' },
    { label: 'R64 Day 2 (Fri)', startDate: '2026-03-20', startTime: '11:00', endDate: '2026-03-21', endTime: '02:00' },
  ]},
  { label: 'Round of 32', windows: [
    { label: 'R32 Day 1 (Sat)', startDate: '2026-03-21', startTime: '11:00', endDate: '2026-03-22', endTime: '02:00' },
    { label: 'R32 Day 2 (Sun)', startDate: '2026-03-22', startTime: '11:00', endDate: '2026-03-23', endTime: '02:00' },
  ]},
  { label: 'Sweet 16', windows: [
    { label: 'Sweet 16 Day 1', startDate: '2026-03-26', startTime: '18:00', endDate: '2026-03-27', endTime: '02:00' },
    { label: 'Sweet 16 Day 2', startDate: '2026-03-27', startTime: '18:00', endDate: '2026-03-28', endTime: '02:00' },
  ]},
  { label: 'Elite Eight', windows: [
    { label: 'Elite Eight Day 1', startDate: '2026-03-28', startTime: '13:00', endDate: '2026-03-29', endTime: '02:00' },
    { label: 'Elite Eight Day 2', startDate: '2026-03-29', startTime: '13:00', endDate: '2026-03-30', endTime: '02:00' },
  ]},
  { label: 'Final Four', windows: [
    { label: 'Final Four (Sat)', startDate: '2026-04-04', startTime: '17:00', endDate: '2026-04-05', endTime: '02:00' },
  ]},
  { label: 'Championship', windows: [
    { label: 'Championship (Mon)', startDate: '2026-04-06', startTime: '20:00', endDate: '2026-04-07', endTime: '02:00' },
  ]},
  { label: 'Full 2026 Tournament', windows: [
    { label: 'First Four Day 1',  startDate: '2026-03-17', startTime: '17:00', endDate: '2026-03-18', endTime: '02:00' },
    { label: 'First Four Day 2',  startDate: '2026-03-18', startTime: '17:00', endDate: '2026-03-19', endTime: '02:00' },
    { label: 'R64 Day 1 (Thu)',   startDate: '2026-03-19', startTime: '11:00', endDate: '2026-03-20', endTime: '02:00' },
    { label: 'R64 Day 2 (Fri)',   startDate: '2026-03-20', startTime: '11:00', endDate: '2026-03-21', endTime: '02:00' },
    { label: 'R32 Day 1 (Sat)',   startDate: '2026-03-21', startTime: '11:00', endDate: '2026-03-22', endTime: '02:00' },
    { label: 'R32 Day 2 (Sun)',   startDate: '2026-03-22', startTime: '11:00', endDate: '2026-03-23', endTime: '02:00' },
    { label: 'Sweet 16 Day 1',    startDate: '2026-03-26', startTime: '18:00', endDate: '2026-03-27', endTime: '02:00' },
    { label: 'Sweet 16 Day 2',    startDate: '2026-03-27', startTime: '18:00', endDate: '2026-03-28', endTime: '02:00' },
    { label: 'Elite Eight Day 1', startDate: '2026-03-28', startTime: '13:00', endDate: '2026-03-29', endTime: '02:00' },
    { label: 'Elite Eight Day 2', startDate: '2026-03-29', startTime: '13:00', endDate: '2026-03-30', endTime: '02:00' },
    { label: 'Final Four',        startDate: '2026-04-04', startTime: '17:00', endDate: '2026-04-05', endTime: '02:00' },
    { label: 'Championship',      startDate: '2026-04-06', startTime: '20:00', endDate: '2026-04-07', endTime: '02:00' },
  ]},
];

const TOUR_REF = [
  ['First Four',   'Tue Mar 17 - Wed Mar 18', '5pm starts'],
  ['Round of 64',  'Thu Mar 19 - Fri Mar 20', '11am starts'],
  ['Round of 32',  'Sat Mar 21 - Sun Mar 22', '11am starts'],
  ['Sweet 16',     'Thu Mar 26 - Fri Mar 27', '6pm starts'],
  ['Elite Eight',  'Sat Mar 28 - Sun Mar 29', '1pm starts'],
  ['Final Four',   'Sat Apr 4',               '5pm starts'],
  ['Championship', 'Mon Apr 6',               '8pm start'],
];

function getNowET() {
  // Use Intl.DateTimeFormat parts for reliable ET parsing
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(now);
  const get = type => parts.find(p => p.type === type)?.value || '00';
  const year = get('year'), month = get('month'), day = get('day');
  let hh = get('hour'), mm = get('minute');
  if (hh === '24') hh = '00'; // midnight edge case
  const date = year + '-' + month + '-' + day;
  const time = hh + ':' + mm;
  return { date, time, ts: date + 'T' + time };
}

function getWindowState(w, isSaved) {
  if (!isSaved) return 'proposed';
  const { ts } = getNowET();
  if (!w.startDate || !w.endDate) return 'upcoming';
  const startTs = w.startDate + 'T' + (w.startTime || '00:00');
  const endTs   = w.endDate   + 'T' + (w.endTime   || '23:59');
  if (ts < startTs) return 'upcoming';
  if (ts > endTs)   return 'past';
  return 'active';
}

function formatWindowSummary(w) {
  if (!w.startDate) {
    const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    const days = (w.days || []).map(d => DAYS[d]).join(', ');
    return (days || 'Every day') + ', ' + (w.startTime||'') + '-' + (w.endTime||'') + ' ET';
  }
  const fmt = d => new Date(d + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return fmt(w.startDate) + ' ' + (w.startTime||'') + ' to ' + fmt(w.endDate) + ' ' + (w.endTime||'') + ' ET';
}

function StateBadge({ state }) {
  if (state === 'proposed') return (
    <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(255,107,0,0.15)', color: 'var(--orange)',
      fontFamily: 'var(--font-condensed)', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px',
      border: '1px solid rgba(255,107,0,0.4)' }}>
      PROPOSED
    </span>
  );
  if (state === 'active') return (
    <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(39,174,96,0.2)', color: 'var(--green)',
      fontFamily: 'var(--font-condensed)', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px',
      display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)',
        display: 'inline-block', animation: 'blink 1s infinite' }} />
      ACTIVE
    </span>
  );
  if (state === 'upcoming') return (
    <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(75,139,190,0.15)',
      color: 'var(--blue)', fontFamily: 'var(--font-condensed)', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px' }}>
      SCHEDULED
    </span>
  );
  return (
    <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(255,255,255,0.05)',
      color: 'var(--gray)', fontFamily: 'var(--font-condensed)', fontSize: '0.7rem', fontWeight: 700,
      letterSpacing: '1px', textDecoration: 'line-through' }}>
      COMPLETED
    </span>
  );
}

export default function AdminPollerPage() {
  const api = useApi();
  const [schedule, setSchedule]   = useState({ enabled: false, windows: [] });
  const [savedSchedule, setSaved] = useState(null);
  const [status, setStatus]       = useState('');
  const [error, setError]         = useState('');
  const [polling, setPolling]     = useState(false);
  const [lastPoll, setLastPoll]   = useState(null);
  const [pollerActive, setActive] = useState(null);
  const [, setTick]               = useState(0);
  const [appConfig, setAppConfig] = useState({ scoresEnabled: true, otherGameRetentionHours: 24, playInRoundName: 'First Four' });
  const [appConfigMsg, setAppConfigMsg] = useState('');

  useEffect(() => {
    api.getPollerSchedule()
      .then(data => {
        const s = data || { enabled: false, windows: [] };
        setSchedule(s);
        setSaved(JSON.stringify(s));
      })
      .catch(e => console.warn('Schedule load:', e.message));

    // Load app config (scoresEnabled, otherGameRetentionHours)
    api.get('/admin/app-config').then(cfg => { if (cfg) setAppConfig(cfg); }).catch(() => {});

    const check = async () => {
      try {
        const r = await fetch(API_BASE + '/poller/active?nocache=true');
        const { active } = await r.json();
        setActive(active);
      } catch (_) {}
    };
    check();
    const si = setInterval(check, 30000);
    const ti = setInterval(() => setTick(t => t + 1), 60000);
    return () => { clearInterval(si); clearInterval(ti); };
  }, []);

  const hasUnsaved = savedSchedule !== null && JSON.stringify(schedule) !== savedSchedule;

  const toast = (msg, ms = 3000) => {
    setStatus(msg);
    setTimeout(() => setStatus(s => s === msg ? '' : s), ms);
  };

  async function handleSaveAppConfig() {
    try {
      await api.put('/admin/app-config', appConfig);
      setAppConfigMsg('✅ Saved!');
      setTimeout(() => setAppConfigMsg(''), 3000);
    } catch (e) { setAppConfigMsg('❌ ' + e.message); }
  }

  async function handleSave() {
    setError(''); setStatus('Saving...');
    try {
      await api.savePollerSchedule(schedule);
      setSaved(JSON.stringify(schedule));
      toast('Schedule saved!');
    } catch (e) { setError(e.message); setStatus(''); }
  }

  async function handlePollNow() {
    setPolling(true); setError(''); setStatus('');
    try {
      const r = await api.pollNow();
      setLastPoll(r.timestamp);
      toast('ESPN poll completed — scores updated!', 4000);
    } catch (e) { setError(e.message); }
    finally { setPolling(false); }
  }

  function addWindow() {
    const { date } = getNowET();
    setSchedule(s => ({ ...s, windows: [...s.windows,
      { label: '', startDate: date, startTime: '11:00', endDate: date, endTime: '23:59' }] }));
  }
  function removeWindow(idx) {
    setSchedule(s => ({ ...s, windows: s.windows.filter((_, i) => i !== idx) }));
  }
  function updateWindow(idx, field, val) {
    setSchedule(s => ({ ...s, windows: s.windows.map((w, i) => i === idx ? { ...w, [field]: val } : w) }));
  }
  function applyPreset(preset, replace = false) {
    if (replace && !window.confirm('Replace all windows with "' + preset.label + '" preset?')) return;
    setSchedule(s => ({ ...s, enabled: true, windows: replace ? preset.windows : [...s.windows, ...preset.windows] }));
    toast((replace ? 'Replaced with' : 'Added') + ' "' + preset.label + '" — click Save to activate.');
  }

  const isActive = pollerActive !== null ? pollerActive
    : (schedule.enabled && schedule.windows.some(w => getWindowState(w) === 'active'));

  // Determine which windows are saved vs proposed
  const savedWindows = savedSchedule ? JSON.parse(savedSchedule).windows || [] : [];
  const isSavedWindow = (w) => savedWindows.some(sw =>
    sw.label === w.label && sw.startDate === w.startDate && sw.startTime === w.startTime
  );

  const sorted = [...schedule.windows]
    .map((w, i) => ({ w, i, state: getWindowState(w, isSavedWindow(w)) }))
    .sort((a, b) => {
      const o = { proposed: 0, active: 1, upcoming: 2, past: 3 };
      if (o[a.state] !== o[b.state]) return o[a.state] - o[b.state];
      const aTs = (a.w.startDate || '') + 'T' + (a.w.startTime || '');
      const bTs = (b.w.startDate || '') + 'T' + (b.w.startTime || '');
      return aTs.localeCompare(bTs);
    });

  const stateStyle = {
    proposed: { border: '1px solid var(--orange)',          background: 'rgba(255,107,0,0.06)' },
    active:   { border: '1px solid var(--green)',           background: 'rgba(39,174,96,0.08)' },
    upcoming: { border: '1px solid var(--slate)',           background: 'var(--navy-light)' },
    past:     { border: '1px solid rgba(255,255,255,0.06)', background: 'rgba(0,0,0,0.2)', opacity: 0.55 },
  };

  return (
    <div>
      <style>{'@keyframes blink{0%,100%{opacity:1}50%{opacity:0.3}}'}</style>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.8rem', color: 'var(--blue)', letterSpacing: '2px', marginBottom: 4 }}>
            ESPN SCORE POLLER
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 10, height: 10, borderRadius: '50%',
              background: isActive ? 'var(--green)' : 'var(--gray)',
              boxShadow: isActive ? '0 0 6px var(--green)' : 'none' }} />
            <span style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.9rem', color: isActive ? 'var(--green)' : 'var(--gray)' }}>
              {isActive ? 'ACTIVE — polling every 2 min' : schedule.enabled ? 'ENABLED — outside schedule window' : 'DISABLED'}
            </span>
            {lastPoll && <span style={{ fontSize: '0.75rem', color: 'var(--gray)' }}>Last poll: {new Date(lastPoll).toLocaleTimeString()}</span>}
          </div>
        </div>
        <button className="btn btn-primary" onClick={handlePollNow} disabled={polling}
          style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 160 }}>
          {polling ? <span>Polling...</span> : <span>Poll ESPN Now</span>}
        </button>
      </div>

      {error  && <div className="alert alert-error"   style={{ marginBottom: 12 }}>{error}</div>}
      {status && <div className="alert alert-success" style={{ marginBottom: 12 }}>{status}</div>}

      <div className="alert alert-info" style={{ marginBottom: 20 }}>
        Polls ESPN every 2 minutes within configured date/time windows.
        <strong> Requires both enabled toggle AND at least one window</strong> to poll.
      </div>

      {/* Enable toggle */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', color: 'var(--cream)', letterSpacing: '1px' }}>AUTOMATIC POLLING</div>
            <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.85rem', color: 'var(--gray)', marginTop: 4 }}>
              Polls ESPN every 2 minutes during schedule windows
            </div>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
            <div style={{ width: 52, height: 28, borderRadius: 14, position: 'relative', cursor: 'pointer',
              background: schedule.enabled ? 'var(--blue)' : 'var(--slate)', transition: 'background 0.2s' }}
              onClick={() => setSchedule(s => ({ ...s, enabled: !s.enabled }))}>
              <div style={{ width: 22, height: 22, borderRadius: '50%', background: 'white', position: 'absolute',
                top: 3, left: schedule.enabled ? 27 : 3, transition: 'left 0.2s', boxShadow: '0 1px 4px rgba(0,0,0,0.3)' }} />
            </div>
            <span style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.9rem',
              color: schedule.enabled ? 'var(--blue)' : 'var(--gray)' }}>
              {schedule.enabled ? 'ENABLED' : 'DISABLED'}
            </span>
          </label>
        </div>
      </div>

      {/* Presets */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header">
          <h3 className="card-title" style={{ fontSize: '1.1rem' }}>2026 TOURNAMENT PRESETS</h3>
          <span style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.82rem', color: 'var(--gray)' }}>
            Click to add windows · Shift+click to replace all
          </span>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {PRESETS.map(p => {
            // Check if this preset's windows are already in the schedule
            const addedCount = p.windows.filter(pw =>
              schedule.windows.some(sw => sw.label === pw.label && sw.startDate === pw.startDate)
            ).length;
            const allAdded = addedCount === p.windows.length;
            const someAdded = addedCount > 0 && !allAdded;
            const isFull = p.label.includes('Full');
            return (
              <button key={p.label} className="btn btn-secondary btn-sm"
                onClick={e => applyPreset(p, e.shiftKey)}
                title={allAdded ? 'Already added (click to add again, Shift+click to replace all)' : 'Click to add · Shift+click to replace all'}
                style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.82rem',
                  borderColor: allAdded ? 'var(--green)' : someAdded ? 'var(--orange)' : isFull ? 'var(--gold)' : '',
                  color: allAdded ? 'var(--green)' : someAdded ? 'var(--orange)' : isFull ? 'var(--gold)' : '',
                  opacity: allAdded ? 0.7 : 1,
                }}>
                {allAdded ? '✓ ' : someAdded ? '~ ' : ''}{p.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Schedule windows */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <h3 className="card-title" style={{ fontSize: '1.1rem', margin: 0 }}>SCHEDULE WINDOWS</h3>
            {hasUnsaved && (
              <span style={{ padding: '2px 8px', borderRadius: 4, border: '1px solid var(--orange)',
                color: 'var(--orange)', fontFamily: 'var(--font-condensed)', fontSize: '0.7rem', fontWeight: 700 }}>
                UNSAVED CHANGES
              </span>
            )}
          </div>
          <div style={{display:'flex',gap:8}}>
            {schedule.windows.length > 0 && (
              <button className="btn btn-danger btn-sm"
                onClick={() => { if(window.confirm('Remove all windows? This will also disable the poller.')) setSchedule(s=>({...s,windows:[],enabled:false})); }}
                style={{fontSize:'0.78rem'}}>Remove All</button>
            )}
            <button className="btn btn-secondary btn-sm" onClick={addWindow}>+ Add Window</button>
          </div>
        </div>

        {schedule.windows.length === 0 ? (
          <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--gray)', fontFamily: 'var(--font-condensed)' }}>
            {'No windows configured — poller will not run until windows are added'}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {sorted.map(({ w, i, state }) => (
              <div key={i} style={{ ...stateStyle[state], borderRadius: 10, padding: 16, transition: 'all 0.3s' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.82rem',
                      color: state === 'proposed' ? 'var(--orange)' : state === 'active' ? 'var(--green)' : state === 'past' ? 'var(--gray)' : 'var(--blue)',
                      letterSpacing: '1px' }}>
                      WINDOW {i + 1}
                    </span>
                    <StateBadge state={state} />
                  </div>
                  <button className="btn btn-danger btn-sm" onClick={() => removeWindow(i)}
                    style={{ fontSize: '0.75rem' }}>Remove</button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: '10px 16px', alignItems: 'center' }}>
                  <label className="form-label" style={{ margin: 0, fontSize: '0.78rem' }}>Label</label>
                  <input className="form-input" value={w.label || ''} placeholder="e.g. R64 Day 1"
                    onChange={e => updateWindow(i, 'label', e.target.value)} style={{ maxWidth: 280 }} />

                  <label className="form-label" style={{ margin: 0, fontSize: '0.78rem' }}>Start (ET)</label>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <input type="date" className="form-input" value={w.startDate || ''}
                      onChange={e => updateWindow(i, 'startDate', e.target.value)} style={{ width: 150 }} />
                    <input type="text" className="form-input" value={w.startTime || ''}
                      onChange={e => updateWindow(i, 'startTime', e.target.value)}
                      placeholder="HH:MM" maxLength={5}
                      style={{ width: 75, fontFamily: 'var(--font-condensed)', letterSpacing: '1px' }} />
                    <span style={{ fontSize: '0.72rem', color: 'var(--gray)', fontFamily: 'var(--font-condensed)' }}>24h ET</span>
                  </div>

                  <label className="form-label" style={{ margin: 0, fontSize: '0.78rem' }}>End (ET)</label>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <input type="date" className="form-input" value={w.endDate || ''}
                      onChange={e => updateWindow(i, 'endDate', e.target.value)} style={{ width: 150 }} />
                    <input type="text" className="form-input" value={w.endTime || ''}
                      onChange={e => updateWindow(i, 'endTime', e.target.value)}
                      placeholder="HH:MM" maxLength={5}
                      style={{ width: 75, fontFamily: 'var(--font-condensed)', letterSpacing: '1px' }} />
                    <span style={{ fontSize: '0.72rem', color: 'var(--gray)', fontFamily: 'var(--font-condensed)' }}>24h ET</span>
                  </div>

                  <label className="form-label" style={{ margin: 0, fontSize: '0.78rem' }}>Summary</label>
                  <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.85rem',
                    color: state === 'past' ? 'var(--gray)' : 'var(--cream)',
                    textDecoration: state === 'past' ? 'line-through' : 'none' }}>
                    {w.label && <strong>{w.label} — </strong>}
                    {formatWindowSummary(w)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Save */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <button className="btn btn-primary btn-lg" onClick={handleSave} style={{
          background: hasUnsaved ? 'var(--orange)' : '',
          boxShadow: hasUnsaved ? '0 0 12px rgba(255,107,0,0.4)' : 'none',
        }}>
          {hasUnsaved ? 'Save Changes' : 'Save Schedule'}
        </button>
        {hasUnsaved && (
          <span style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.82rem', color: 'var(--orange)' }}>
            You have unsaved changes
          </span>
        )}
      </div>

      {/* Scores Page Settings */}
      <div className="card" style={{ marginTop: 24 }}>
        <div className="card-header">
          <h3 className="card-title" style={{ fontSize: '1.1rem' }}>SCORES PAGE SETTINGS</h3>
        </div>
        <div style={{ padding: '16px 0', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.95rem', color: 'var(--cream)' }}>
                Scores Tab
              </div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.8rem', color: 'var(--gray)', marginTop: 2 }}>
                Hide the Scores tab from all users (useful if there's a polling glitch)
              </div>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
              fontFamily: 'var(--font-condensed)', fontSize: '0.9rem',
              color: appConfig.scoresEnabled ? 'var(--green)' : 'var(--red)' }}>
              <input type="checkbox" checked={appConfig.scoresEnabled}
                onChange={e => setAppConfig(c => ({ ...c, scoresEnabled: e.target.checked }))} />
              {appConfig.scoresEnabled ? 'Enabled (visible to users)' : 'Disabled (hidden from users)'}
            </label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.95rem', color: 'var(--cream)' }}>
                Play-In Round Name
              </div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.8rem', color: 'var(--gray)', marginTop: 2 }}>
                What to call the Play-In round throughout the app (e.g. "First Four", "Faker Round")
              </div>
            </div>
            <input className="form-input" value={appConfig.playInRoundName}
              onChange={e => setAppConfig(c => ({ ...c, playInRoundName: e.target.value }))}
              style={{ width: 180 }} maxLength={30} placeholder="First Four" />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.95rem', color: 'var(--cream)' }}>
                Other Games Retention
              </div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.8rem', color: 'var(--gray)', marginTop: 2 }}>
                Auto-delete non-tournament games from the Other tab after this many hours
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="number" min="1" max="168" value={appConfig.otherGameRetentionHours}
                onChange={e => setAppConfig(c => ({ ...c, otherGameRetentionHours: Number(e.target.value) }))}
                className="form-input" style={{ width: 80, textAlign: 'center' }} />
              <span style={{ fontFamily: 'var(--font-condensed)', color: 'var(--gray)', fontSize: '0.85rem' }}>hours</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="btn btn-primary btn-sm" onClick={handleSaveAppConfig}>Save Settings</button>
            {appConfigMsg && <span style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.85rem',
              color: appConfigMsg.startsWith('✅') ? 'var(--green)' : 'var(--red)' }}>{appConfigMsg}</span>}
          </div>
        </div>
      </div>

      {/* Reference */}
      <div className="card" style={{ marginTop: 24 }}>
        <div className="card-header">
          <h3 className="card-title" style={{ fontSize: '1rem' }}>2026 TOURNAMENT SCHEDULE REFERENCE</h3>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 8 }}>
          {TOUR_REF.map(([round, dates, note]) => (
            <div key={round} style={{ background: 'var(--navy-light)', border: '1px solid var(--slate)', borderRadius: 8, padding: '10px 12px' }}>
              <div style={{ fontFamily: 'var(--font-condensed)', fontWeight: 700, fontSize: '0.85rem', color: 'var(--blue)', textTransform: 'uppercase', letterSpacing: '1px' }}>{round}</div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.8rem', color: 'var(--gray)', marginTop: 2 }}>{dates}</div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '0.75rem', color: 'var(--slate)', marginTop: 1 }}>{note}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
